import { LoanApplicationDtoBorrowerAllowed } from 'src/generated-api-client';
import { borrowerApi, bpmsResourcesManagerApi } from 'src/services/apiServices';
import { BasicStore } from 'src/utils/mobx/BasicStore/BasicStore';
import { BasicStoreApi } from 'src/utils/mobx/BasicStore/BasicStore.types';
import { RequestHelper } from 'src/utils/RequestHelper';

export class ApplicationsStoreClass extends BasicStore<LoanApplicationDtoBorrowerAllowed> {
    formKey = 'embedded:deployment:forms/bp/bp-01-loan-application-info.json';
    api: BasicStoreApi<LoanApplicationDtoBorrowerAllowed> = {
        loadList: async (...args) => {
            const options = RequestHelper.getOptionsFromArgs(args);

            const response = await RequestHelper.unwrapFromAxiosPromise(
                borrowerApi.getBorrowerApplications(
                    { page: DEFAULT_PAGE, size: DEFAULT_SIZE },
                    options,
                ),
            );

            return response.content || [];
        },
        loadItem: (id: number, ...args) => {
            const options = RequestHelper.getOptionsFromArgs(args);

            return RequestHelper.unwrapFromAxiosPromise(
                borrowerApi.getBorrowerApplication({ id }, options),
            );
        },

        loadItemForm: (...args) => {
            const options = RequestHelper.getOptionsFromArgs(args);

            return RequestHelper.unwrapFromAxiosPromise(
                bpmsResourcesManagerApi.getForm(
                    { formKey: this.formKey },
                    options,
                ),
            );
        },
    };
}

const DEFAULT_PAGE = 0;
const DEFAULT_SIZE = 100;

export const ApplicationsStore = new ApplicationsStoreClass();
